import React from 'react';
import { useSelector } from 'react-redux';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';

import header from '../../assets/urop_projects/header';
import { UropProject, UropProjects as UropProjectsType, State } from '../../types';
import { colorPalette, screenWidthSettings } from '../../constants';
import PageHeader from '../PageHeader';
import ScrollUpButton from '../ScrollUpButton';
import UropProjectCard from './UropProjectCard';
import UropProjectRefineResults from './UropProjectRefineResults';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      color: 'black',
      minHeight: '100vh',
      width: '100vw',
      maxWidth: screenWidthSettings.maxScreenWidth,
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 0,
    },
    contentContainer: {
      overflow: 'hidden', //prevents scrollbar from appearing when project card animates
      minHeight: '100vh',
      width: '100%',
      maxWidth: screenWidthSettings.maxScreenWidth,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 0,
    },
  })
);

const UropProjects = () => {
  const classes = useStyles();
  const currentProjects = useSelector(
    (state: State): UropProjectsType => state.uropReducer?.displayProjects || []
  );

  return (
    <Container className={classes.root} component='section'>
      <PageHeader
        title='UROP Projects'
        coverPhoto={header.coverPhoto}
        headerStatement={header.headerStatement}
        dividerColor={colorPalette.yellow}
        scrollToElementID='urop-refine-results'
      />
      <Container className={classes.contentContainer}>
        <UropProjectRefineResults />
        {currentProjects.map(
          (project: UropProject): JSX.Element => {
            return <UropProjectCard project={project} key={project.id} />;
          }
        )}
      </Container>
      <ScrollUpButton arrowColor={colorPalette.yellow} />
    </Container>
  );
};

export default UropProjects;
